module.exports = {"verify_now":"Verify now","verify_now_content":"Use iDIN to verify your identity","verify_later":"Verify later","verify_later_content":"I'm over the age of 18 \n and will verify my age later","OR":"Or"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/idin.json
// module id = 528
// module chunks = 245 970